import ToggleButton from './header-toggle';
import HeaderSticky from './header-sticky';

// Search toggle button
document.querySelectorAll('.header__button-search-toggle').forEach($toggleButton => new ToggleButton($toggleButton));

// Navigation toggle button
document.querySelectorAll('.header__button-navigation-toggle').forEach($toggleButton => new ToggleButton($toggleButton));

// Sticky header
document.querySelectorAll('.header__main').forEach($panel => new HeaderSticky($panel));
